import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, Card, Input, Localized } from "../../components/admin/Fields";

const AdminMenusPage = () => {
  const [menus, setMenus] = useState([]);
  const [selected, setSelected] = useState(null);
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get("/admin/menus");
    setMenus(data);
    if (!selected && data.length) {
      setSelected(data[0]);
      setItems(data[0].items || []);
    }
  };
  useEffect(() => { load(); }, []);

  const pick = (m) => { setSelected(m); setItems(m.items || []); };
  const updateItem = (i, patch) => setItems((arr) => arr.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));
  const removeItem = (i) => setItems((arr) => arr.filter((_, idx) => idx !== i));
  const addItem = () => setItems((arr) => [...arr, { label: { tr: "", en: "" }, url: "/", target: "_self", children: [] }]);

  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/menus/${selected.id}`, { ...selected, items });
      toast.success("Kaydedildi"); await load();
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-menus-page">
      <AdminHeader eyebrow="Navigation" title="Menü Yönetimi" action={selected ? <Btn onClick={save} disabled={busy} testId="menu-save">Kaydet</Btn> : null} />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-3">
          <div className="bg-white border border-black/5 divide-y divide-black/5">
            {menus.map((m) => (
              <button key={m.id} onClick={() => pick(m)} className={`w-full text-left px-4 py-3 text-sm ${selected?.id === m.id ? "bg-brand-light text-brand-navy" : "text-brand-dark"}`} data-testid={`menu-key-${m.key}`}>
                {m.name} <span className="text-brand-medium">({m.key})</span>
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-9 space-y-4">
          {selected ? (
            <>
              {items.map((it, i) => (
                <Card key={i} title={`Öğe ${i + 1}`} action={<Btn variant="danger" onClick={() => removeItem(i)}><Trash2 size={12} /></Btn>}>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="md:col-span-2"><Localized value={it.label} onChange={(v) => updateItem(i, { label: v })} /></div>
                    <Input label="URL" value={it.url} onChange={(v) => updateItem(i, { url: v })} />
                  </div>
                </Card>
              ))}
              <Btn onClick={addItem} testId="add-menu-item"><Plus size={14} /> Yeni Öğe</Btn>
            </>
          ) : <div className="text-brand-medium">Menü seçin.</div>}
        </div>
      </div>
    </div>
  );
};

export default AdminMenusPage;
